<!--
   Created by qing on 2021/2/5
   Des: 
-->
<template>
  <div class="order-center-container" v-wechat-title="`订单中心`">

    <div class="header">
      <div class="des">
        共{{pageInfo.totalCount}}条
      </div>
      <div class="search-container" @click="orderQuery">
        <van-icon name="search" />
        <div>订单查询</div>
      </div>
    </div>

    <div class="list-container" v-if="loadingEnd">
      <van-list
        v-if="orderList && orderList.length"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad">

        <order-item
          :orderList="orderList"
        ></order-item>

      </van-list>

      <div v-else class="empty-data-container">
        <img src="../../../assets/images/allproject.png" alt="">
        暂无订单
      </div>
    </div>

  </div>
</template>

<script>
  import {accurateFormatDate} from "../../../assets/js/Untis";
  import OrderItem from "../../component/OrderItem";

  export default {
    data() {
      return {
        loadingEnd: false,
        loading: false,
        finished: false,
        orderList: [],
        filterInfo: {
          orderId: "",  // 订单号筛选 选填
          thirdOrderId: "", //第三方订单号
          appId: "",  //应用筛选 选填
          formId: "", //表单筛选 选填
          startTime: null,  //下单时间筛选 选填
          endTime: null, //下单时间筛选 选填
          payWay: "", //WEI_CHAT_PAY 微信支付 支付方式筛选 选填
          openId: "", //微信 openId 筛选
          orderStatus: "", //  WAIT 待支付 FINISH 已支付 TIMEOUT 超时  CLOSE 已关闭  REFUNDED 已退款 订单状态筛选
        },
        pageInfo: {
          currentPage: 0,
          pageSize: 20,
          totalPage: 0,
          totalCount: 0
        },

      }
    },
    components: {
      OrderItem
    },
    created() {
      this.fetchOrderInfo()
      this.$store.dispatch('setPageTitle', '订单中心')
    },
    methods: {
      formatTime(d) {
        return accurateFormatDate(d)
      },

      // 加载更多数据
      onLoad() {
        this.fetchOrderInfo()
      },

      fetchOrderInfo() {
        this.pageInfo.currentPage += 1
        this.$store.dispatch('actionCompanyPaymentList', {
          selfFlag: 1,
          ...this.pageInfo,
          ...this.filterInfo
        }).then(res => {
          this.payedTotal = res.payedTotal
          this.waitTotal = res.waitTotal
          this.refundTotal = res.refundTotal
          this.orderList.push(...res.pageInfo.dataList)
          this.pageInfo.totalPage = res.pageInfo.totalPage
          this.pageInfo.currentPage = res.pageInfo.currentPage
          this.pageInfo.totalCount = res.pageInfo.totalCount
          if (res.pageInfo.totalPage <= res.pageInfo.currentPage) {
            this.finished = true
          }
        }).catch(console.error)
          .finally(() => {
            this.loadingEnd = true
            this.loading = false
            if (this.toast) this.toast.clear()
          })
      },

      orderQuery() {
        this.$router.push({
          name: 'orderQuery'
        })
      }
    }
  }
</script>

<style lang="less">

  .order-center-container {
    height: calc(100% - env(safe-area-inset-bottom));

    .header {
      height: 40px;
      background-color: #ffffff;
      /*border-top: 4px solid #F6F6F6;*/
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      border-bottom: 1px solid #e6e6e6;

      .des {
        color: #9f9f9f;
        font-size: 13px;
      }


      .search-container {
        display: flex;
        align-items: center;
        height: 100%;

        .van-icon {
          font-size: 20px;
          margin-right: 5px;
          color: #4A66FA;
        }

        div {
          font-size: 13px;
          color: #4A66FA;
        }
      }
    }

    .list-container {
      height: calc(100% - 40px);
      overflow: auto;
      -webkit-overflow-scrolling: touch;

    }
  }
</style>